export default class CategoryList {
    constructor() {
        this.scrollTo('.category_list')
        this.morePosts();
    }

    morePosts() {
        const loadMore = document.querySelector('.shortcuts_component #load-more');
        const loadContent = document.querySelector('.shortcuts_component #load-content');

        if (!loadMore || !loadContent) return;

        loadMore.addEventListener('click', () => {
            loadMore.disabled = true;
            let { ajax_url, ajax_nonce } = main_data;

            let {
                dataset: {
                    name,
                    qtd,
                    paged,
                    total
                },
            } = loadMore;

            paged = parseInt(paged);

            let send = `action=ias_load_more&security=${ajax_nonce}&name=${name}&qtd=${qtd}&paged=${paged + 1}`;

            let options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
                body: send,
            };

            fetch(ajax_url, options)
                .then((response) => response.json())
                .then((json) => {
                    if (json) {
                        loadContent.insertAdjacentHTML("beforeend", json);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    const updatePaged = paged + 1;

                    if (updatePaged < total) {
                        loadMore.dataset.paged = updatePaged;
                        loadMore.disabled = false;
                    } else {
                        loadMore.remove();
                    }
                });
        })
    }

    scrollTo(element) {
        function offset(el) {
            let rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }

        let filterComponent = offset(document.querySelector(element));

        if (window.location.pathname.split('/').length > 5) {
            window.scroll({ top: (filterComponent.top - 30), left: 0, behavior: 'smooth' })
        }
    }
}
new CategoryList();